import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarClavesSatCentrosCosto,
  type ListarClavesSatCentrosCostoParams,
} from "../services/clave-sat-centro-costo-service";

/**
 * Listado PAGINADO server-side · query options compartidas entre el loader del route y el
 * componente. La key extiende `qk.adminClavesSatCentrosCosto` para que los invalidate de las
 * mutations alcancen por prefijo.
 */
export const clavesSatCentrosCostoQueryOptions = (params: ListarClavesSatCentrosCostoParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminClavesSatCentrosCosto, "paginado", params] as const,
    queryFn: () => listarClavesSatCentrosCosto(params),
    placeholderData: keepPreviousData,
  });

export function useClavesSatCentrosCosto(params: ListarClavesSatCentrosCostoParams = {}) {
  return useQuery(clavesSatCentrosCostoQueryOptions(params));
}
